import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  SEND_VERIFY_CODE,
  SEND_VERIFY_CODE_ERROR,
  SEND_VERIFY_CODE_SUCCESS,
  SET_VERIFY_ITEM,
  CONFIRM_VERIFY_CODE,
  CONFIRM_VERIFY_CODE_ERROR,
  CONFIRM_VERIFY_CODE_SUCCESS,
  CLEAR_CONFIRM_VERIFY_CODE_ERROR_DATA,
} from '../type';
import { initialState } from './initialize';

const verifyAccountReducer = handleActions(
  new Map([
    [
      SEND_VERIFY_CODE,
      state => {
        return update(state, {
          sendVerifyData: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      SEND_VERIFY_CODE_ERROR,
      (state, action) => {
        return update(state, {
          sendVerifyData: {
            error: { $set: action.payload },
            loading: { $set: false },
          },
        });
      },
    ],
    [
      SEND_VERIFY_CODE_SUCCESS,
      (state, action) => {
        return update(state, {
          sendVerifyData: {
            data: { $set: action.payload },
            loading: { $set: false },
          },
        });
      },
    ],
    [
      SET_VERIFY_ITEM,
      (state, action) => {
        return update(state, {
          sendVerifyData: {
            verifyItem: { $set: action.payload },
          },
        });
      },
    ],
    [
      CONFIRM_VERIFY_CODE,
      state => {
        return update(state, {
          confirmCodeData: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      CONFIRM_VERIFY_CODE_ERROR,
      (state, action) => {
        return update(state, {
          confirmCodeData: {
            loading: { $set: false },
            error: { $set: action.payload },
          },
        });
      },
    ],
    [
      CONFIRM_VERIFY_CODE_SUCCESS,
      (state, action) => {
        return update(state, {
          confirmCodeData: {
            loading: { $set: false },
            data: { $set: action.payload },
          },
        });
      },
    ],
    [
      CLEAR_CONFIRM_VERIFY_CODE_ERROR_DATA,
      state => {
        return update(state, {
          confirmCodeData: {
            error: { $set: null },
          },
        });
      },
    ],
  ]),
  initialState,
);

export default verifyAccountReducer;
